export const OrganizationSettings: any = {
    UserManualLink: 'UserManualLink',
    FacilitatorManualLink: 'FacilitatorManualLink',
    HeaderBackgroundColor: 'HeaderBackgroundColor',
    HeaderTextColor: 'HeaderTextColor',
    SponsoredContentImage: 'SponsoredContentImage',
    LogoHeight: 'LogoHeight',
};
